function _readOnlyError(r) { throw new TypeError('"' + r + '" is read-only'); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var adapters = {
  logger: typeof console !== "undefined" ? console : undefined,
  WebSocket: typeof WebSocket !== "undefined" ? WebSocket : undefined
};
var logger = {
  log: function log() {
    if (this.enabled) {
      var _adapters$logger;
      for (var _len = arguments.length, messages = new Array(_len), _key = 0; _key < _len; _key++) {
        messages[_key] = arguments[_key];
      }
      messages.push(Date.now());
      (_adapters$logger = adapters.logger).log.apply(_adapters$logger, ["[ActionCable]"].concat(messages));
    }
  }
};
var now = function now() {
  return new Date().getTime();
};
var secondsSince = function secondsSince(time) {
  return (now() - time) / 1e3;
};
var ConnectionMonitor = /*#__PURE__*/function () {
  function ConnectionMonitor(connection) {
    _classCallCheck(this, ConnectionMonitor);
    this.visibilityDidChange = this.visibilityDidChange.bind(this);
    this.connection = connection;
    this.reconnectAttempts = 0;
  }
  return _createClass(ConnectionMonitor, [{
    key: "start",
    value: function start() {
      if (!this.isRunning()) {
        this.startedAt = now();
        delete this.stoppedAt;
        this.startPolling();
        addEventListener("visibilitychange", this.visibilityDidChange);
        logger.log("ConnectionMonitor started. stale threshold = ".concat(this.constructor.staleThreshold, " s"));
      }
    }
  }, {
    key: "stop",
    value: function stop() {
      if (this.isRunning()) {
        this.stoppedAt = now();
        this.stopPolling();
        removeEventListener("visibilitychange", this.visibilityDidChange);
        logger.log("ConnectionMonitor stopped");
      }
    }
  }, {
    key: "isRunning",
    value: function isRunning() {
      return this.startedAt && !this.stoppedAt;
    }
  }, {
    key: "recordMessage",
    value: function recordMessage() {
      this.pingedAt = now();
    }
  }, {
    key: "recordConnect",
    value: function recordConnect() {
      this.reconnectAttempts = 0;
      delete this.disconnectedAt;
      logger.log("ConnectionMonitor recorded connect");
    }
  }, {
    key: "recordDisconnect",
    value: function recordDisconnect() {
      this.disconnectedAt = now();
      logger.log("ConnectionMonitor recorded disconnect");
    }
  }, {
    key: "startPolling",
    value: function startPolling() {
      this.stopPolling();
      this.poll();
    }
  }, {
    key: "stopPolling",
    value: function stopPolling() {
      clearTimeout(this.pollTimeout);
    }
  }, {
    key: "poll",
    value: function poll() {
      var _this = this;
      this.pollTimeout = setTimeout(function () {
        _this.reconnectIfStale();
        _this.poll();
      }, this.getPollInterval());
    }
  }, {
    key: "getPollInterval",
    value: function getPollInterval() {
      var _this$constructor = this.constructor,
        staleThreshold = _this$constructor.staleThreshold,
        reconnectionBackoffRate = _this$constructor.reconnectionBackoffRate;
      var backoff = Math.pow(1 + reconnectionBackoffRate, Math.min(this.reconnectAttempts, 10));
      var jitterMax = this.reconnectAttempts === 0 ? 1 : reconnectionBackoffRate;
      var jitter = jitterMax * Math.random();
      return staleThreshold * 1e3 * backoff * (1 + jitter);
    }
  }, {
    key: "reconnectIfStale",
    value: function reconnectIfStale() {
      if (this.connectionIsStale()) {
        logger.log("ConnectionMonitor detected stale connection. reconnectAttempts = ".concat(this.reconnectAttempts, ", time stale = ").concat(secondsSince(this.refreshedAt), " s, stale threshold = ").concat(this.constructor.staleThreshold, " s"));
        this.reconnectAttempts++;
        if (this.disconnectedRecently()) {
          logger.log("ConnectionMonitor skipping reopening recent disconnect. time disconnected = ".concat(secondsSince(this.disconnectedAt), " s"));
        } else {
          logger.log("ConnectionMonitor reopening");
          this.connection.reopen();
        }
      }
    }
  }, {
    key: "refreshedAt",
    get: function get() {
      return this.pingedAt ? this.pingedAt : this.startedAt;
    }
  }, {
    key: "connectionIsStale",
    value: function connectionIsStale() {
      return secondsSince(this.refreshedAt) > this.constructor.staleThreshold;
    }
  }, {
    key: "disconnectedRecently",
    value: function disconnectedRecently() {
      return this.disconnectedAt && secondsSince(this.disconnectedAt) < this.constructor.staleThreshold;
    }
  }, {
    key: "visibilityDidChange",
    value: function visibilityDidChange() {
      var _this2 = this;
      if (document.visibilityState === "visible") {
        setTimeout(function () {
          if (_this2.connectionIsStale() || !_this2.connection.isOpen()) {
            logger.log("ConnectionMonitor reopening stale connection on visibilitychange. visibilityState = ".concat(document.visibilityState));
            _this2.connection.reopen();
          }
        }, 200);
      }
    }
  }]);
}();
ConnectionMonitor.staleThreshold = 6;
ConnectionMonitor.reconnectionBackoffRate = .15;
var INTERNAL = {
  message_types: {
    welcome: "welcome",
    disconnect: "disconnect",
    ping: "ping",
    confirmation: "confirm_subscription",
    rejection: "reject_subscription"
  },
  disconnect_reasons: {
    unauthorized: "unauthorized",
    invalid_request: "invalid_request",
    server_restart: "server_restart",
    remote: "remote"
  },
  default_mount_path: "/cable",
  protocols: ["actioncable-v1-json", "actioncable-unsupported"]
};
var message_types = INTERNAL.message_types,
  protocols = INTERNAL.protocols;
var supportedProtocols = protocols.slice(0, protocols.length - 1);
var indexOf = [].indexOf;
var Connection = /*#__PURE__*/function () {
  function Connection(consumer) {
    _classCallCheck(this, Connection);
    this.open = this.open.bind(this);
    this.consumer = consumer;
    this.subscriptions = this.consumer.subscriptions;
    this.monitor = new ConnectionMonitor(this);
    this.disconnected = true;
  }
  return _createClass(Connection, [{
    key: "send",
    value: function send(data) {
      if (this.isOpen()) {
        this.webSocket.send(JSON.stringify(data));
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: "open",
    value: function open() {
      if (this.isActive()) {
        logger.log("Attempted to open WebSocket, but existing socket is ".concat(this.getState()));
        return false;
      } else {
        var socketProtocols = [].concat(_toConsumableArray(protocols), _toConsumableArray(this.consumer.subprotocols || []));
        logger.log("Opening WebSocket, current state is ".concat(this.getState(), ", subprotocols: ").concat(socketProtocols));
        if (this.webSocket) {
          this.uninstallEventHandlers();
        }
        this.webSocket = new adapters.WebSocket(this.consumer.url, socketProtocols);
        this.installEventHandlers();
        this.monitor.start();
        return true;
      }
    }
  }, {
    key: "close",
    value: function close() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
          allowReconnect: true
        },
        allowReconnect = _ref.allowReconnect;
      if (!allowReconnect) {
        this.monitor.stop();
      }
      if (this.isOpen()) {
        return this.webSocket.close();
      }
    }
  }, {
    key: "reopen",
    value: function reopen() {
      logger.log("Reopening WebSocket, current state is ".concat(this.getState()));
      if (this.isActive()) {
        try {
          return this.close();
        } catch (error) {
          logger.log("Failed to reopen WebSocket", error);
        } finally {
          logger.log("Reopening WebSocket in ".concat(this.constructor.reopenDelay, "ms"));
          setTimeout(this.open, this.constructor.reopenDelay);
        }
      } else {
        return this.open();
      }
    }
  }, {
    key: "getProtocol",
    value: function getProtocol() {
      if (this.webSocket) {
        return this.webSocket.protocol;
      }
    }
  }, {
    key: "isOpen",
    value: function isOpen() {
      return this.isState("open");
    }
  }, {
    key: "isActive",
    value: function isActive() {
      return this.isState("open", "connecting");
    }
  }, {
    key: "triedToReconnect",
    value: function triedToReconnect() {
      return this.monitor.reconnectAttempts > 0;
    }
  }, {
    key: "isProtocolSupported",
    value: function isProtocolSupported() {
      return indexOf.call(supportedProtocols, this.getProtocol()) >= 0;
    }
  }, {
    key: "isState",
    value: function isState() {
      for (var _len2 = arguments.length, states = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        states[_key2] = arguments[_key2];
      }
      return indexOf.call(states, this.getState()) >= 0;
    }
  }, {
    key: "getState",
    value: function getState() {
      if (this.webSocket) {
        for (var state in adapters.WebSocket) {
          if (adapters.WebSocket[state] === this.webSocket.readyState) {
            return state.toLowerCase();
          }
        }
      }
      return null;
    }
  }, {
    key: "installEventHandlers",
    value: function installEventHandlers() {
      for (var eventName in this.events) {
        var handler = this.events[eventName].bind(this);
        this.webSocket["on".concat(eventName)] = handler;
      }
    }
  }, {
    key: "uninstallEventHandlers",
    value: function uninstallEventHandlers() {
      for (var eventName in this.events) {
        this.webSocket["on".concat(eventName)] = function () {};
      }
    }
  }]);
}();
Connection.reopenDelay = 500;
Connection.prototype.events = {
  message: function message(event) {
    if (!this.isProtocolSupported()) {
      return;
    }
    var _JSON$parse = JSON.parse(event.data),
      identifier = _JSON$parse.identifier,
      message = _JSON$parse.message,
      reason = _JSON$parse.reason,
      reconnect = _JSON$parse.reconnect,
      type = _JSON$parse.type;
    this.monitor.recordMessage();
    switch (type) {
      case message_types.welcome:
        if (this.triedToReconnect()) {
          this.reconnectAttempted = true;
        }
        this.monitor.recordConnect();
        return this.subscriptions.reload();
      case message_types.disconnect:
        logger.log("Disconnecting. Reason: ".concat(reason));
        return this.close({
          allowReconnect: reconnect
        });
      case message_types.ping:
        return null;
      case message_types.confirmation:
        this.subscriptions.confirmSubscription(identifier);
        if (this.reconnectAttempted) {
          this.reconnectAttempted = false;
          return this.subscriptions.notify(identifier, "connected", {
            reconnected: true
          });
        } else {
          return this.subscriptions.notify(identifier, "connected", {
            reconnected: false
          });
        }
      case message_types.rejection:
        return this.subscriptions.reject(identifier);
      default:
        return this.subscriptions.notify(identifier, "received", message);
    }
  },
  open: function open() {
    logger.log("WebSocket onopen event, using '".concat(this.getProtocol(), "' subprotocol"));
    this.disconnected = false;
    if (!this.isProtocolSupported()) {
      logger.log("Protocol is unsupported. Stopping monitor and disconnecting.");
      return this.close({
        allowReconnect: false
      });
    }
  },
  close: function close(event) {
    logger.log("WebSocket onclose event");
    if (this.disconnected) {
      return;
    }
    this.disconnected = true;
    this.monitor.recordDisconnect();
    return this.subscriptions.notifyAll("disconnected", {
      willAttemptReconnect: this.monitor.isRunning()
    });
  },
  error: function error() {
    logger.log("WebSocket onerror event");
  }
};
var extend = function extend(object, properties) {
  if (properties != null) {
    for (var key in properties) {
      var value = properties[key];
      object[key] = value;
    }
  }
  return object;
};
var Subscription = /*#__PURE__*/function () {
  function Subscription(consumer) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var mixin = arguments.length > 2 ? arguments[2] : undefined;
    _classCallCheck(this, Subscription);
    this.consumer = consumer;
    this.identifier = JSON.stringify(params);
    extend(this, mixin);
  }
  return _createClass(Subscription, [{
    key: "perform",
    value: function perform(action) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      data.action = action;
      return this.send(data);
    }
  }, {
    key: "send",
    value: function send(data) {
      return this.consumer.send({
        command: "message",
        identifier: this.identifier,
        data: JSON.stringify(data)
      });
    }
  }, {
    key: "unsubscribe",
    value: function unsubscribe() {
      return this.consumer.subscriptions.remove(this);
    }
  }]);
}();
var SubscriptionGuarantor = /*#__PURE__*/function () {
  function SubscriptionGuarantor(subscriptions) {
    _classCallCheck(this, SubscriptionGuarantor);
    this.subscriptions = subscriptions;
    this.pendingSubscriptions = [];
  }
  return _createClass(SubscriptionGuarantor, [{
    key: "guarantee",
    value: function guarantee(subscription) {
      if (this.pendingSubscriptions.indexOf(subscription) == -1) {
        logger.log("SubscriptionGuarantor guaranteeing ".concat(subscription.identifier));
        this.pendingSubscriptions.push(subscription);
      } else {
        logger.log("SubscriptionGuarantor already guaranteeing ".concat(subscription.identifier));
      }
      this.startGuaranteeing();
    }
  }, {
    key: "forget",
    value: function forget(subscription) {
      logger.log("SubscriptionGuarantor forgetting ".concat(subscription.identifier));
      this.pendingSubscriptions = this.pendingSubscriptions.filter(function (s) {
        return s !== subscription;
      });
    }
  }, {
    key: "startGuaranteeing",
    value: function startGuaranteeing() {
      this.stopGuaranteeing();
      this.retrySubscribing();
    }
  }, {
    key: "stopGuaranteeing",
    value: function stopGuaranteeing() {
      clearTimeout(this.retryTimeout);
    }
  }, {
    key: "retrySubscribing",
    value: function retrySubscribing() {
      var _this3 = this;
      this.retryTimeout = setTimeout(function () {
        if (_this3.subscriptions && typeof _this3.subscriptions.subscribe === "function") {
          _this3.pendingSubscriptions.map(function (subscription) {
            logger.log("SubscriptionGuarantor resubscribing ".concat(subscription.identifier));
            _this3.subscriptions.subscribe(subscription);
          });
        }
      }, 500);
    }
  }]);
}();
var Subscriptions = /*#__PURE__*/function () {
  function Subscriptions(consumer) {
    _classCallCheck(this, Subscriptions);
    this.consumer = consumer;
    this.guarantor = new SubscriptionGuarantor(this);
    this.subscriptions = [];
  }
  return _createClass(Subscriptions, [{
    key: "create",
    value: function create(channelName, mixin) {
      var channel = channelName;
      var params = _typeof(channel) === "object" ? channel : {
        channel: channel
      };
      var subscription = new Subscription(this.consumer, params, mixin);
      return this.add(subscription);
    }
  }, {
    key: "add",
    value: function add(subscription) {
      this.subscriptions.push(subscription);
      this.consumer.ensureActiveConnection();
      this.notify(subscription, "initialized");
      this.subscribe(subscription);
      return subscription;
    }
  }, {
    key: "remove",
    value: function remove(subscription) {
      this.forget(subscription);
      if (!this.findAll(subscription.identifier).length) {
        this.sendCommand(subscription, "unsubscribe");
      }
      return subscription;
    }
  }, {
    key: "reject",
    value: function reject(identifier) {
      var _this4 = this;
      return this.findAll(identifier).map(function (subscription) {
        _this4.forget(subscription);
        _this4.notify(subscription, "rejected");
        return subscription;
      });
    }
  }, {
    key: "forget",
    value: function forget(subscription) {
      this.guarantor.forget(subscription);
      this.subscriptions = this.subscriptions.filter(function (s) {
        return s !== subscription;
      });
      return subscription;
    }
  }, {
    key: "findAll",
    value: function findAll(identifier) {
      return this.subscriptions.filter(function (s) {
        return s.identifier === identifier;
      });
    }
  }, {
    key: "reload",
    value: function reload() {
      var _this5 = this;
      return this.subscriptions.map(function (subscription) {
        return _this5.subscribe(subscription);
      });
    }
  }, {
    key: "notifyAll",
    value: function notifyAll(callbackName) {
      var _this6 = this;
      for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
        args[_key3 - 1] = arguments[_key3];
      }
      return this.subscriptions.map(function (subscription) {
        return _this6.notify.apply(_this6, [subscription, callbackName].concat(args));
      });
    }
  }, {
    key: "notify",
    value: function notify(subscription, callbackName) {
      for (var _len4 = arguments.length, args = new Array(_len4 > 2 ? _len4 - 2 : 0), _key4 = 2; _key4 < _len4; _key4++) {
        args[_key4 - 2] = arguments[_key4];
      }
      var subscriptions;
      if (typeof subscription === "string") {
        subscriptions = this.findAll(subscription);
      } else {
        subscriptions = [subscription];
      }
      return subscriptions.map(function (subscription) {
        return typeof subscription[callbackName] === "function" ? subscription[callbackName].apply(subscription, args) : undefined;
      });
    }
  }, {
    key: "subscribe",
    value: function subscribe(subscription) {
      if (this.sendCommand(subscription, "subscribe")) {
        this.guarantor.guarantee(subscription);
      }
    }
  }, {
    key: "confirmSubscription",
    value: function confirmSubscription(identifier) {
      var _this7 = this;
      logger.log("Subscription confirmed ".concat(identifier));
      this.findAll(identifier).map(function (subscription) {
        return _this7.guarantor.forget(subscription);
      });
    }
  }, {
    key: "sendCommand",
    value: function sendCommand(subscription, command) {
      var identifier = subscription.identifier;
      return this.consumer.send({
        command: command,
        identifier: identifier
      });
    }
  }]);
}();
var Consumer = /*#__PURE__*/function () {
  function Consumer(url) {
    _classCallCheck(this, Consumer);
    this._url = url;
    this.subscriptions = new Subscriptions(this);
    this.connection = new Connection(this);
    this.subprotocols = [];
  }
  return _createClass(Consumer, [{
    key: "url",
    get: function get() {
      return createWebSocketURL(this._url);
    }
  }, {
    key: "send",
    value: function send(data) {
      return this.connection.send(data);
    }
  }, {
    key: "connect",
    value: function connect() {
      return this.connection.open();
    }
  }, {
    key: "disconnect",
    value: function disconnect() {
      return this.connection.close({
        allowReconnect: false
      });
    }
  }, {
    key: "ensureActiveConnection",
    value: function ensureActiveConnection() {
      if (!this.connection.isActive()) {
        return this.connection.open();
      }
    }
  }, {
    key: "addSubProtocol",
    value: function addSubProtocol(subprotocol) {
      this.subprotocols = [].concat(_toConsumableArray(this.subprotocols), [subprotocol]);
    }
  }]);
}();
function createWebSocketURL(url) {
  if (typeof url === "function") {
    url = url();
  }
  if (url && !/^wss?:/i.test(url)) {
    var a = document.createElement("a");
    a.href = url;
    a.href = a.href;
    a.protocol = a.protocol.replace("http", "ws");
    return a.href;
  } else {
    return url;
  }
}
function createConsumer() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getConfig("url") || INTERNAL.default_mount_path;
  return new Consumer(url);
}
function getConfig(name) {
  var element = document.head.querySelector("meta[name='action-cable-".concat(name, "']"));
  if (element) {
    return element.getAttribute("content");
  }
}
export { Connection, ConnectionMonitor, Consumer, INTERNAL, Subscription, SubscriptionGuarantor, Subscriptions, adapters, createConsumer, createWebSocketURL, getConfig, logger };